/**
 * Whether the entity passes the quick filter, matching any part of it regardless of case.
 * If quick filter doesn't exist, it returns true
 */
export function doesEntityPassQuickFilter({
  quickFilter,
  quickFilterEntity
}) {
  return quickFilter === "" || quickFilterEntity.toLowerCase().includes(quickFilter.toLowerCase());
}
/** Whether the entity value in a column passes any filter selected by user or not */
export function doesColumnPassAnyFilter({
  entity,
  allPossibleFiltersForColumn,
  activeFilterIds
}) {
  return activeFilterIds.some(filterId => {
    // An ID from the URL may have no option, e.g. the current user as creator when they created nothing
    const filter = allPossibleFiltersForColumn[filterId];
    return filter?.hasEntityPassedFilter(entity) ?? false;
  });
}